import styled from 'styled-components';
import { Collapse } from 'antd';

export const Container = styled(Collapse)`
  .ant-collapse-expand-icon svg {
    height: 1rem;
    width: 1rem;
  }
`;
